document.addEventListener("turbo:load", () => {
  const element = document.querySelector("[data-polygona-slug]");
  if (!element) return

  import(
    /* webpackChunkName: "polygona_service" */ "../services/polygona_service"
  ).then(({ polygonaRender }) => {
    polygonaRender(element);
  });
});
